const features = [
  {
    id: 1,
    icon: 'ri-fire-line',
    title: '实时热度追踪',
    desc: '每日追踪全网日漫讨论热度，热门排行每小时自动刷新，让你永远站在追漫第一线，不错过任何一个话题爆点。',
  },
  {
    id: 2,
    icon: 'ri-team-line',
    title: '编辑精选推荐',
    desc: '专业编辑团队精心策划日漫推荐，从类型、主题、读者偏好等多维度筛选，帮你从海量作品中找到真正值得读的好漫画。',
  },
  {
    id: 3,
    icon: 'ri-bookmark-line',
    title: '完整资源索引',
    desc: '收录超过12000部日本漫画作品信息，涵盖少年、少女、青年、BL、GL等全类型，经典老番与最新连载一应俱全。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台特色
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70 text-center"
            >
              <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}